import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import classList from 'flarum/common/utils/classList';
import BadgeMedal from './BadgeMedal';
import { badgeUrl } from '../utils';
/** O emblema em pílula (medalha pequena + nome): o cartão do usuário e o resumo. */
export default class BadgeChip extends Component {
  view() {
    const {
      badge,
      username,
      count,
      className
    } = this.attrs;
    return m(Link, {
      className: classList('CanelaBadgeChip', `CanelaBadgeChip--${badge.type()}`, className),
      href: badgeUrl(badge, username),
      title: badge.description() || undefined
    }, m(BadgeMedal, {
      badge: badge,
      size: "small"
    }), m("span", {
      className: "CanelaBadgeChip-name"
    }, badge.name()), !!count && count > 1 && m("span", {
      className: "CanelaBadgeChip-count"
    }, "\xD7", count));
  }
}
flarum.reg.add('ramon-canela', 'forum/features/badges/components/BadgeChip', BadgeChip);